export default __webpack_public_path__ + "static/media/___Kuvempu.add90c70.jpg";